export default "__VITE_ASSET__1RC0bZBZ__"